<mat-dialog-content class="mat-typography">
    <h2 class="broker-modal-title">{{ translateService.instant("ExamsAssociationMgnt") }}</h2>
    <div class="content-wrapper">
        @if (exams(); as exams) {
            <mat-card #exams class="exams">
                <mat-card-header class="card-heading">
                    <mat-card-title>
                        <span>{{ translateService.instant("SearchResult") }}</span>
                        @if (exams && exams.length) {
                            <span> ({{ exams.length }} {{ translateService.instant("GridItemCount") }}) </span>
                        }
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content style="min-height: 15vh">
                    <ag-grid-angular
                        id="examstable"
                        (gridSizeChanged)="onGridSizeChanged($event)"
                        (firstDataRendered)="onFirstDataRendered($event, 'exams')"
                        [autoSizeStrategy]="autoSizeStrategy"
                        [columnDefs]="columnDefs"
                        [rowHeight]="rowHeight"
                        [overlayNoRowsTemplate]="noRowsTemplate"
                        [rowSelection]="rowSelection"
                        (rowSelected)="onRowSelected($event, 'exams')"
                        (selectionChanged)="onSelectedItemsChange($event, 'exams')"
                        [rowData]="dataSource()"
                        [modules]="agGridModuls"
                        [theme]="agGridTheme"
                        style="width: 100%; height: 100%"
                    >
                    </ag-grid-angular>
                </mat-card-content>
            </mat-card>
        }
        <mat-card #filters class="filters">
            <div class="column-div" #patient>
                <h3 style="padding-bottom: 10px; padding-top: 7px">{{ translateService.instant("PatientFilters") }}</h3>

                @if (patientSearchForm) {
                    <form [formGroup]="patientSearchForm">
                        <div class="input-fields-wrapper">
                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("LastName") }}</mat-label>
                                <input matInput formControlName="cognome" />
                                <button
                                    class="small-icon-button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Clear"
                                    (click)="resetFormControl('patient', 'cognome')"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("FirstName") }}</mat-label>
                                <input matInput formControlName="nome" />
                                <button
                                    class="small-icon-button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Clear"
                                    (click)="resetFormControl('patient', 'nome')"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("Sex") }}</mat-label>
                                <mat-select
                                    (selectionChange)="onValueChange('patient', 'sesso', $event)"
                                    [typeaheadDebounceInterval]="500"
                                    formControlName="sesso"
                                >
                                    <ng-container>
                                        @for (item of sexes(); track item.id) {
                                            <mat-option [value]="item.id">
                                                {{ item.description }}
                                            </mat-option>
                                        }
                                    </ng-container>
                                </mat-select>
                                <button
                                    class="small-icon-button"
                                    (click)="resetFormControl('patient', 'sesso')"
                                    mat-icon-button
                                    matSuffix
                                    type="button"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>

                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("BirthDate") }}</mat-label>
                                <input
                                    (dateChange)="onValueChange('patient', 'dataNascita', $event)"
                                    (keydown.enter)="$event.preventDefault()"
                                    (keydown.space)="$event.preventDefault()"
                                    [matDatepicker]="dataNascita"
                                    formControlName="dataNascita"
                                    matInput
                                />
                                <div matSuffix>
                                    <button
                                        class="medium-icon-button"
                                        mat-icon-button
                                        type="button"
                                        (click)="dataNascita.open()"
                                    >
                                        <mat-icon>today</mat-icon>
                                    </button>
                                    <button
                                        class="small-icon-button"
                                        (click)="resetFormControl('patient', 'dataNascita')"
                                        mat-icon-button
                                        type="button"
                                    >
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                <mat-datepicker #dataNascita type="date"></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </form>
                }
            </div>
            <div class="column-div" #studies>
                <div class="filters-header">
                    <h3>{{ translateService.instant("StudyFilters") }}</h3>
                    <div class="buttons">
                        <button mat-icon-button [matTooltip]="translateService.instant('Research')" (click)="search()">
                            <mat-icon>search</mat-icon>
                        </button>
                        <button
                            mat-icon-button
                            [matTooltip]="translateService.instant('DeleteFilters')"
                            (click)="resetForms()"
                        >
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </div>
                </div>

                @if (studiesSearchForm) {
                    <form [formGroup]="studiesSearchForm">
                        <div class="input-fields-wrapper">
                            <!-- fromDate -->
                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("From") }}</mat-label>
                                <input
                                    (dateChange)="onValueChange('study', 'fromDate', $event)"
                                    (keydown.enter)="$event.preventDefault()"
                                    (keydown.space)="$event.preventDefault()"
                                    [matDatepicker]="fromDate"
                                    formControlName="fromDate"
                                    [max]="maxDate"
                                    matInput
                                />
                                <div matSuffix>
                                    <!--<mat-datepicker-toggle [for]="fromDate"></mat-datepicker-toggle>-->
                                    <button
                                        class="medium-icon-button"
                                        mat-icon-button
                                        type="button"
                                        (click)="fromDate.open()"
                                    >
                                        <mat-icon>today</mat-icon>
                                    </button>
                                    <button
                                        class="small-icon-button"
                                        (click)="resetFormControl('study', 'fromDate')"
                                        mat-icon-button
                                        type="button"
                                    >
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                <mat-datepicker #fromDate type="date"></mat-datepicker>
                            </mat-form-field>
                            <!-- toDate -->
                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("To") }}</mat-label>
                                <input
                                    (dateChange)="onValueChange('study', 'toDate', $event)"
                                    (keydown.enter)="$event.preventDefault()"
                                    (keydown.space)="$event.preventDefault()"
                                    [matDatepicker]="toDate"
                                    formControlName="toDate"
                                    [min]="minDate"
                                    matInput
                                />
                                <div matSuffix>
                                    <!--<mat-datepicker-toggle [for]="toDate"></mat-datepicker-toggle>-->
                                    <button
                                        class="medium-icon-button"
                                        mat-icon-button
                                        type="button"
                                        (click)="toDate.open()"
                                    >
                                        <mat-icon>today</mat-icon>
                                    </button>
                                    <button
                                        class="small-icon-button"
                                        (click)="resetFormControl('study', 'toDate')"
                                        mat-icon-button
                                        type="button"
                                    >
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>
                                <mat-datepicker #toDate type="date"></mat-datepicker>
                            </mat-form-field>
                            <!-- Typology -->
                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("Typology") }}</mat-label>
                                <mat-select
                                    (selectionChange)="onValueChange('study', 'typology', $event)"
                                    [typeaheadDebounceInterval]="500"
                                    formControlName="typology"
                                >
                                    <ng-container>
                                        @for (item of typologies(); track item.code) {
                                            <mat-option [value]="item.code">
                                                {{ item.studyDescription }}
                                            </mat-option>
                                        }
                                    </ng-container>
                                </mat-select>
                                <button
                                    class="small-icon-button"
                                    (click)="resetFormControl('study', 'typology')"
                                    mat-icon-button
                                    matSuffix
                                    type="button"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                            <!-- Description -->
                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("Description") }}</mat-label>
                                <input matInput formControlName="description" />
                                <button
                                    class="small-icon-button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Clear"
                                    (click)="resetFormControl('study', 'description')"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                            <!-- modality -->
                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("Modality") }}</mat-label>
                                <mat-select
                                    (selectionChange)="onValueChange('study', 'modality', $event)"
                                    [typeaheadDebounceInterval]="500"
                                    formControlName="modality"
                                >
                                    <ng-container>
                                        @if (this.studyFilterSearch()?.modality) {
                                            <mat-option default [value]="this.studyFilterSearch()?.modality">
                                                {{ this.studyFilterSearch()?.modality ?? '' }}
                                            </mat-option>
                                        }
                                        @for (item of modalities(); track item) {
                                            <mat-option [value]="item.description">
                                                {{ item.description }}
                                            </mat-option>
                                        }
                                    </ng-container>
                                </mat-select>
                                <button
                                    class="small-icon-button"
                                    (click)="resetFormControl('study', 'modality')"
                                    mat-icon-button
                                    matSuffix
                                    type="button"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                            <!-- Top -->
                            <mat-form-field appearance="outline" floatLabel="auto">
                                <mat-label>{{ translateService.instant("Top") }}</mat-label>
                                <input matInput type="number" formControlName="top" />
                                <button
                                    class="small-icon-button"
                                    matSuffix
                                    mat-icon-button
                                    aria-label="Clear"
                                    (click)="resetFormControl('study', 'top')"
                                >
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                    </form>
                }
            </div>
        </mat-card>

        <mat-card #studySearchResults class="studySearchResults">
            @if (dataSourceSearchResult(); as searchResults) {
                <mat-card-header class="card-heading">
                    <mat-card-title>
                        <span>{{ translateService.instant("SearchResult") }}</span>

                        @if (searchResults && searchResults.length) {
                            <span> ({{ searchResults.length }} {{ translateService.instant("GridItemCount") }}) </span>
                        }
                    </mat-card-title>
                </mat-card-header>
                <mat-card-content style="min-height: 15vh">
                    <ag-grid-angular
                        #searchresultTable
                        id="searchresultTable"
                        (gridSizeChanged)="onGridSizeChanged($event)"
                        [autoSizeStrategy]="autoSizeStrategy"
                        [columnDefs]="columnDefs"
                        [rowHeight]="rowHeight"
                        [rowData]="searchResults"
                        [overlayNoRowsTemplate]="noRowsTemplate"
                        [rowSelection]="rowSelection"
                        (rowSelected)="onRowSelected($event, 'studies')"
                        (selectionChanged)="onSelectedItemsChange($event, 'studies')"
                        (firstDataRendered)="onFirstDataRendered($event, 'studies')"
                        [modules]="agGridModuls"
                        [theme]="agGridTheme"
                        style="width: 100%; height: 100%"
                    >
                    </ag-grid-angular>
                </mat-card-content>
            } @else {
                <mat-card-header class="card-heading">
                    <mat-card-title>
                        <span>{{ translateService.instant("SearchResult") }}</span>
                    </mat-card-title>
                </mat-card-header>
            }
        </mat-card>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button class="btn-themed" (click)="associateStudies()" [disabled]="!canAssociate()">
        {{ translateService.instant("Associate") }}
    </button>
    <button mat-button class="btn-themed" (click)="removeAssociation()" [disabled]="!canRemoveAssociation()">
        {{ translateService.instant("RemoveAssociation") }}
    </button>
    <button mat-button class="btn-themed" (click)="validateAssociation()" [disabled]="!canValidateAssociation()">
        {{ translateService.instant("ValidateAssociation") }}
    </button>
    <button mat-button class="btn-themed" (click)="openImages()" [disabled]="!canImages()">
        {{ translateService.instant("Images") }}
    </button>

    <button mat-button class="btn-themed" (click)="closeDialog()" cdkFocusInitial>
        {{ translateService.instant("Close") }}
    </button>
</mat-dialog-actions>
